import { PortMessage } from '../../../../types/PortMessage';
import { Button } from '../../../cdl/Button/Button';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';

import { EditPortForm } from './EditPortForm';

interface EditPortButtonProps {
    port: PortMessage;
}

export const EditPortButton = ({ port }: EditPortButtonProps) => {
    const { push, pop } = useDrawer();
    const { addToast } = useToasts();

    const openPortEditModal = () => {
        const onModalClose = () => {
            pop(drawerId);
            addToast(translate('port.updatePortSuccessToast'));
        };

        const drawerId = push({
            header: { title: translate('port.editTitle') },
            content: <EditPortForm onSuccess={onModalClose} port={port} />,
        });
    };

    return <Button onClick={openPortEditModal}>{translate('actions.edit')}</Button>;
};
